import React from 'react';

import { LogoutFromPretend } from './assets';
import { IconPrentendLogout, Button } from './elements';
import { useClickStreamContext } from '../ClickStream';
import { PretendsApi, UserApi } from 'api';
import useUserData from 'hooks/useUserData';

const Logout = () => {
  const { logPageEvent } = useClickStreamContext();
  const userData = useUserData();
  const exit = async () => {
    await UserApi.logout();
    localStorage.setItem('UPR_logged', 'false');

    logPageEvent({
      eventType: 'user_logout',
      eventInfo: 'Пользователь разлогинился',
    });
    window.location.reload();
  };

  const exitPretend = async () => {
    logPageEvent({
      eventType: 'user_pretend_exit',
      eventInfo: 'Вышел из притенда',
    });

    await PretendsApi.stopPretends();
    window.location.reload();
  };

  return userData?.isPretended ? (
    <Button onClick={exitPretend}>
      <IconPrentendLogout>{LogoutFromPretend}</IconPrentendLogout>
      ВЕРНУТЬСЯ В КАБИНЕТ
    </Button>
  ) : (
    <Button onClick={exit} data-qa-id="exitButton">
      ВЫХОД
    </Button>
  );
};

export default Logout;
